import React from "react";
import { TextControlSize, TextControlStyle } from "../Utilities/FormDesignConstants";
import { PropertyEditorBoolean } from "../../CommonUI/PropertyEditing/PropertyEditorBoolean";
import {
    PropertyEditorTextSizeSelection,
    PropertyEditorTextStyleSelection,
} from "../../CommonUI/PropertyEditing/PropertyEditorTextStyleSelection";
import { PropertyEditorText } from "../../CommonUI/PropertyEditing/PropertyEditorText";
import { DataFormControl } from "./DataFormControl";
import { PropertyEditorInteger } from "../../CommonUI/PropertyEditing/PropertyEditorInteger";
import { DataUtilities } from "../../rule-engine-core/Common/DataUtilities";
import { PropertyEditorCollapse } from "../../CommonUI/PropertyEditing/PropertyEditorCollapse";
import { UISpacedBoxContent } from "../../CommonUI/BuildlingBlocks/UISpacedBoxContent";

export abstract class TextEntryFormControl extends DataFormControl {
    hintText?: string;
    placeholderText?: string;

    overrideStyle: boolean = false;
    style?: TextControlStyle;
    size?: TextControlSize;

    fullWidth: boolean = true;
    // only show if not full width
    width?: number;

    renderTextStyleSelectionEditor() {
        return (
            <UISpacedBoxContent>
                <PropertyEditorBoolean
                    editObject={this}
                    label="Override Text Style"
                    propertyName="overrideStyle"
                />
                <PropertyEditorCollapse
                    editObject={this}
                    collapseLogicOrField={"overrideStyle"}
                >
                    <PropertyEditorTextStyleSelection
                        propertyName={"style"}
                        editObject={this}
                        parentDefaultValue={this.getFormContext()?.form.defaultTextStyle}
                    />
                    <PropertyEditorTextSizeSelection
                        propertyName={"size"}
                        editObject={this}
                        parentDefaultValue={this.getFormContext()?.form.defaultTextSize}
                    />
                </PropertyEditorCollapse>
            </UISpacedBoxContent>
        );
    }

    renderTextControlBasePropertyEditor() {
        return (
            <UISpacedBoxContent>
                <PropertyEditorText
                    label={"Hint Text"}
                    propertyName={"hintText"}
                    editObject={this}
                />
                <PropertyEditorText
                    label={"Placeholder Text"}
                    propertyName={"placeholderText"}
                    editObject={this}
                />
                <PropertyEditorBoolean
                    label={"Full Width"}
                    propertyName={"fullWidth"}
                    editObject={this}
                />
                <PropertyEditorCollapse
                    editObject={this}
                    collapseLogicOrField={"fullWidth"}
                    showIfFalse={true}
                >
                    <PropertyEditorInteger
                        label={"Width"}
                        propertyName={"width"}
                        editObject={this}
                    />
                </PropertyEditorCollapse>
            </UISpacedBoxContent>
        );
    }

    getStorageData(): object {
        let retData = super.getStorageData();

        retData = DataUtilities.addStorageData(
            this,
            retData,
            "hintText",
            "placeholderText",
            "overrideStyle",
            "style",
            "size",
            "fullWidth",
            "width",
        );

        return retData;
    }

    setStorageData(data: object): void {
        super.setStorageData(data);

        DataUtilities.setStorageData(
            this,
            data,
            "hintText",
            "placeholderText",
            "overrideStyle",
            "style",
            "size",
            "fullWidth",
            "width",
        );
    }
}
